<admin-app-header></admin-app-header>

<div class="users-page">
    <div class="container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <h1>Users & Access Management</h1>
        </div>

        <!-- Loading State -->
        <div class="loading-state" *ngIf="loading">
            <i class="fa-solid fa-spinner fa-spin"></i>
            <p>Loading users...</p>
        </div>

        <div *ngIf="!loading" class="sections-container">
            <!-- Administrators Section -->
            <div class="section-card">
                <div class="section-header">
                    <div class="section-title">
                        <i class="fa-solid fa-shield-halved"></i>
                        <h2>Administrators</h2>
                        <span class="badge">{{ administrators.length }}</span>
                    </div>
                    <p class="section-description">Users with full administrative access to the platform.</p>
                    <button class="btn btn-primary" (click)="openAddAdministratorModal()"><i class="fa-solid fa-plus"></i> Add Administrator</button>
                </div>

                <div class="empty-state" *ngIf="administrators.length === 0">
                    <i class="fa-solid fa-user-slash"></i>
                    <p>No administrators configured yet.</p>
                </div>

                <table class="data-table" *ngIf="administrators.length > 0">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Active</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let admin of administrators">
                            <td>
                                <span class="user-name">{{ getUserDisplayInfo(admin.$key!).name }}</span>
                            </td>
                            <td>
                                <span class="user-email">{{ getUserDisplayInfo(admin.$key!).email || admin.$key }}</span>
                            </td>
                            <td>
                                <label class="toggle-switch">
                                    <input type="checkbox" [checked]="admin.active" (change)="toggleAdministratorActive(admin)" />
                                    <span class="toggle-slider"></span>
                                </label>
                            </td>
                            <td>
                                <button class="action-btn action-btn--delete" (click)="deleteAdministrator(admin)" data-tooltip="Remove">
                                    <i class="fa-solid fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Sales Managers Section -->
            <div class="section-card">
                <div class="section-header">
                    <div class="section-title">
                        <i class="fa-solid fa-user-tie"></i>
                        <h2>Sales Managers</h2>
                        <span class="badge">{{ salesManagers.length }}</span>
                    </div>
                    <p class="section-description">Users with the Sales Manager role can only access the Parker CRM and can only see leads assigned to them.</p>
                    <button class="btn btn-primary" (click)="openAddSalesManagerModal()"><i class="fa-solid fa-plus"></i> Add Sales Manager</button>
                </div>

                <div class="empty-state" *ngIf="salesManagers.length === 0">
                    <i class="fa-solid fa-user-slash"></i>
                    <p>No sales managers configured yet.</p>
                </div>

                <table class="data-table" *ngIf="salesManagers.length > 0">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Active</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let sm of salesManagers">
                            <td>
                                <span class="user-name">{{ getUserDisplayInfo(sm.$key!).name }}</span>
                            </td>
                            <td>
                                <span class="user-email">{{ getUserDisplayInfo(sm.$key!).email || sm.$key }}</span>
                            </td>
                            <td>
                                <label class="toggle-switch">
                                    <input type="checkbox" [checked]="sm.active" (change)="toggleSalesManagerActive(sm)" />
                                    <span class="toggle-slider"></span>
                                </label>
                            </td>
                            <td>
                                <button class="action-btn action-btn--delete" (click)="deleteSalesManager(sm)" data-tooltip="Remove">
                                    <i class="fa-solid fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- CRM Assignees Section -->
            <div class="section-card">
                <div class="section-header">
                    <div class="section-title">
                        <i class="fa-solid fa-users"></i>
                        <h2>CRM Assignees</h2>
                        <span class="badge">{{ crmAssignees.length }}</span>
                    </div>
                    <p class="section-description">Users who can be assigned to leads in the Parker CRM. These appear in the "User Responsible" dropdown.</p>
                    <button class="btn btn-primary" (click)="openAddCrmAssigneeModal()"><i class="fa-solid fa-plus"></i> Add CRM Assignee</button>
                </div>

                <div class="empty-state" *ngIf="crmAssignees.length === 0">
                    <i class="fa-solid fa-user-slash"></i>
                    <p>No CRM assignees configured yet.</p>
                </div>

                <table class="data-table" *ngIf="crmAssignees.length > 0">
                    <thead>
                        <tr>
                            <th>Display Name</th>
                            <th>Badge Color</th>
                            <th>Email</th>
                            <th>Active</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let assignee of crmAssignees">
                            <td>
                                <input
                                    type="text"
                                    class="inline-edit"
                                    [value]="assignee.displayName"
                                    (blur)="updateCrmAssigneeDisplayName(assignee, $any($event.target).value)"
                                    (keyup.enter)="$any($event.target).blur()"
                                />
                            </td>
                            <td>
                                <div class="color-picker-cell">
                                    <span class="badge-preview" [style.background-color]="assignee.badgeColor || '#6c757d'">{{ assignee.displayName?.charAt(0) || '?' }}</span>
                                    <select class="color-select" [value]="assignee.badgeColor || '#6c757d'" (change)="updateCrmAssigneeBadgeColor(assignee, $any($event.target).value)">
                                        <option *ngFor="let color of badgeColors" [value]="color.color">{{ color.name }}</option>
                                    </select>
                                </div>
                            </td>
                            <td>
                                <span class="user-email">{{ getUserDisplayInfo(assignee.$key!).email || assignee.$key }}</span>
                            </td>
                            <td>
                                <label class="toggle-switch">
                                    <input type="checkbox" [checked]="assignee.active" (change)="toggleCrmAssigneeActive(assignee)" />
                                    <span class="toggle-slider"></span>
                                </label>
                            </td>
                            <td>
                                <button class="action-btn action-btn--delete" (click)="deleteCrmAssignee(assignee)" data-tooltip="Remove">
                                    <i class="fa-solid fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- Add Administrator Modal -->
<div class="modal-overlay" *ngIf="showAddAdministratorModal" (click)="closeAddAdministratorModal()">
    <div class="modal-card" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2><i class="fa-solid fa-shield-halved"></i> Add Administrator</h2>
            <button class="modal-close" (click)="closeAddAdministratorModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="modal-body">
            <form [formGroup]="addAdministratorForm">
                <div class="form-field">
                    <label>Email Address *</label>
                    <div class="input-with-button">
                        <input type="email" formControlName="email" placeholder="user@example.com" (keyup.enter)="lookupAdministratorByEmail()" />
                        <button type="button" class="btn btn-secondary btn-sm" (click)="lookupAdministratorByEmail()" [disabled]="!addAdministratorForm.get('email')?.valid">
                            <i class="fa-solid fa-search"></i> Look Up
                        </button>
                    </div>
                    <small class="form-hint">Enter the user's email address to find their account.</small>
                </div>

                <!-- Lookup Result -->
                <div class="lookup-result lookup-result--success" *ngIf="administratorLookupResult">
                    <i class="fa-solid fa-circle-check"></i>
                    <div class="lookup-info">
                        <strong>{{ administratorLookupResult.displayName }}</strong>
                        <span>{{ administratorLookupResult.email }}</span>
                    </div>
                </div>

                <!-- Lookup Error -->
                <div class="lookup-result lookup-result--error" *ngIf="administratorLookupError">
                    <i class="fa-solid fa-circle-xmark"></i>
                    <span>{{ administratorLookupError }}</span>
                </div>

                <div class="modal-actions">
                    <button type="button" class="btn btn-secondary" (click)="closeAddAdministratorModal()">Cancel</button>
                    <button type="button" class="btn btn-primary" [disabled]="!administratorLookupResult || isAddingAdministrator" (click)="addAdministrator()">
                        <i *ngIf="isAddingAdministrator" class="fa-solid fa-spinner fa-spin"></i>
                        <span *ngIf="!isAddingAdministrator">Add Administrator</span>
                        <span *ngIf="isAddingAdministrator">Adding...</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Add Sales Manager Modal -->
<div class="modal-overlay" *ngIf="showAddSalesManagerModal" (click)="closeAddSalesManagerModal()">
    <div class="modal-card" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2><i class="fa-solid fa-user-tie"></i> Add Sales Manager</h2>
            <button class="modal-close" (click)="closeAddSalesManagerModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="modal-body">
            <form [formGroup]="addSalesManagerForm">
                <div class="form-field">
                    <label>Email Address *</label>
                    <div class="input-with-button">
                        <input type="email" formControlName="email" placeholder="user@example.com" (keyup.enter)="lookupSalesManagerByEmail()" />
                        <button type="button" class="btn btn-secondary btn-sm" (click)="lookupSalesManagerByEmail()" [disabled]="!addSalesManagerForm.get('email')?.valid">
                            <i class="fa-solid fa-search"></i> Look Up
                        </button>
                    </div>
                    <small class="form-hint">Enter the user's email address to find their account.</small>
                </div>

                <!-- Lookup Result -->
                <div class="lookup-result lookup-result--success" *ngIf="salesManagerLookupResult">
                    <i class="fa-solid fa-circle-check"></i>
                    <div class="lookup-info">
                        <strong>{{ salesManagerLookupResult.displayName }}</strong>
                        <span>{{ salesManagerLookupResult.email }}</span>
                    </div>
                </div>

                <!-- Lookup Error -->
                <div class="lookup-result lookup-result--error" *ngIf="salesManagerLookupError">
                    <i class="fa-solid fa-circle-xmark"></i>
                    <span>{{ salesManagerLookupError }}</span>
                </div>

                <div class="modal-actions">
                    <button type="button" class="btn btn-secondary" (click)="closeAddSalesManagerModal()">Cancel</button>
                    <button type="button" class="btn btn-primary" [disabled]="!salesManagerLookupResult || isAddingSalesManager" (click)="addSalesManager()">
                        <i *ngIf="isAddingSalesManager" class="fa-solid fa-spinner fa-spin"></i>
                        <span *ngIf="!isAddingSalesManager">Add Sales Manager</span>
                        <span *ngIf="isAddingSalesManager">Adding...</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Add CRM Assignee Modal -->
<div class="modal-overlay" *ngIf="showAddCrmAssigneeModal" (click)="closeAddCrmAssigneeModal()">
    <div class="modal-card" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h2><i class="fa-solid fa-user-plus"></i> Add CRM Assignee</h2>
            <button class="modal-close" (click)="closeAddCrmAssigneeModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        <div class="modal-body">
            <form [formGroup]="addCrmAssigneeForm">
                <div class="form-field">
                    <label>Email Address *</label>
                    <div class="input-with-button">
                        <input type="email" formControlName="email" placeholder="user@example.com" (keyup.enter)="lookupCrmAssigneeByEmail()" />
                        <button type="button" class="btn btn-secondary btn-sm" (click)="lookupCrmAssigneeByEmail()" [disabled]="!addCrmAssigneeForm.get('email')?.valid">
                            <i class="fa-solid fa-search"></i> Look Up
                        </button>
                    </div>
                    <small class="form-hint">Enter the user's email address to find their account.</small>
                </div>

                <!-- Lookup Result -->
                <div class="lookup-result lookup-result--success" *ngIf="crmAssigneeLookupResult">
                    <i class="fa-solid fa-circle-check"></i>
                    <div class="lookup-info">
                        <strong>{{ crmAssigneeLookupResult.displayName }}</strong>
                        <span>{{ crmAssigneeLookupResult.email }}</span>
                    </div>
                </div>

                <!-- Lookup Error -->
                <div class="lookup-result lookup-result--error" *ngIf="crmAssigneeLookupError">
                    <i class="fa-solid fa-circle-xmark"></i>
                    <span>{{ crmAssigneeLookupError }}</span>
                </div>

                <div class="form-field" *ngIf="crmAssigneeLookupResult">
                    <label>Display Name *</label>
                    <input type="text" formControlName="displayName" placeholder="e.g., John Smith" />
                    <small class="form-hint">This name will appear in the CRM dropdown when assigning leads.</small>
                </div>

                <div class="form-field" *ngIf="crmAssigneeLookupResult">
                    <label>Badge Color</label>
                    <div class="color-picker-field">
                        <span class="badge-preview-large" [style.background-color]="addCrmAssigneeForm.get('badgeColor')?.value || '#6c757d'">
                            {{ addCrmAssigneeForm.get('displayName')?.value?.charAt(0) || '?' }}
                        </span>
                        <div class="color-swatches">
                            <button
                                *ngFor="let color of badgeColors"
                                type="button"
                                class="color-swatch"
                                [style.background-color]="color.color"
                                [class.selected]="addCrmAssigneeForm.get('badgeColor')?.value === color.color"
                                (click)="addCrmAssigneeForm.get('badgeColor')?.setValue(color.color)"
                                [attr.title]="color.name"
                            ></button>
                        </div>
                    </div>
                    <small class="form-hint">Choose a color for this assignee's badge in the CRM.</small>
                </div>

                <div class="modal-actions">
                    <button type="button" class="btn btn-secondary" (click)="closeAddCrmAssigneeModal()">Cancel</button>
                    <button type="button" class="btn btn-primary" [disabled]="!crmAssigneeLookupResult || !addCrmAssigneeForm.valid || isAddingCrmAssignee" (click)="addCrmAssignee()">
                        <i *ngIf="isAddingCrmAssignee" class="fa-solid fa-spinner fa-spin"></i>
                        <span *ngIf="!isAddingCrmAssignee">Add CRM Assignee</span>
                        <span *ngIf="isAddingCrmAssignee">Adding...</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

